<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="订单类型" prop="type"><br>
				<el-radio v-model="inputmodel.type" label="1">水费</el-radio>
				<el-radio v-model="inputmodel.type" label="2">电费</el-radio>
				<el-radio v-model="inputmodel.type" label="3">房租</el-radio>
				<el-radio v-model="inputmodel.type" label="4">押金差额</el-radio>
			</el-form-item>
			<!-- <el-form-item label="支付类型" prop="pay_type"><br>
				<el-radio v-model="inputmodel.pay_type" label="1">小程序支付</el-radio>
				<el-radio v-model="inputmodel.pay_type" label="2">线下支付</el-radio>
			</el-form-item>
			<el-form-item label="支付状态" prop="pay_status"><br>
				<el-radio v-model="inputmodel.pay_status" label="0">待支付</el-radio>
				<el-radio v-model="inputmodel.pay_status" label="1">已支付</el-radio>
			</el-form-item> -->

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		bill_edit
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '房间号',
					model: 'room_num'
				}, {
					name: '用户姓名',
					model: 'user_name'
				}, {
					name: '金额',
					model: 'money'
				}],
				inputmodel: {
					type: '',
					room_num: '',
					user_name: '',
					money: '',
					user_name: '',
					// pay_type: '',
					// pay_status: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
					rent_status: 0
				}
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							bill_edit(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.type == '水费') {
				this.inputmodel.type = '1'
			} else if (this.item.type == '电费') {
				this.inputmodel.type = '2'
			} else if (this.item.type == '房租') {
				this.inputmodel.type = '3'
			} else if (this.item.type == '押金差额') {
				this.inputmodel.type = '4'
			}
			if (this.item.pay_type == '小程序支付') {
				this.inputmodel.pay_type = '1'
			} else if (this.item.pay_type == '线下支付') {
				this.inputmodel.pay_type = '2'
			}
			if (this.item.pay_status == '待支付') {
				this.inputmodel.pay_status = '0'
			} else if (this.item.pay_status == '已支付') {
				this.inputmodel.pay_status = '1'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.type == '水费') {
					this.inputmodel.type = '1'
				} else if (this.item.type == '电费') {
					this.inputmodel.type = '2'
				} else if (this.item.type == '房租') {
					this.inputmodel.type = '3'
				} else if (this.item.type == '押金差额') {
					this.inputmodel.type = '4'
				}
				if (this.item.pay_type == '小程序支付') {
					this.inputmodel.pay_type = '1'
				} else if (this.item.pay_type == '线下支付') {
					this.inputmodel.pay_type = '2'
				}
				if (this.item.pay_status == '待支付') {
					this.inputmodel.pay_status = '0'
				} else if (this.item.pay_status == '已支付') {
					this.inputmodel.pay_status = '1'
				}
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>